import { useEffect, useMemo, useState } from "react";
import { jwtDecode } from "jwt-decode";
import useMsalAuth from "./useMsalAuth";
import useMiddlewareAuth from "./useMiddlewareAuth";
import useImpersonate from "./useImpersonate";
import axiosManager from "../../services/axiosManager";

export default function useUserAuth() {
    const [isTokenSet, setIsTokenSet] = useState(false);

    // STEP 0 (for DEBUG ONLY - impersonate token)
    const { tokenImpersonate, clearImpersonation } = useImpersonate();
    const isImpersonated = !!tokenImpersonate;

    // STEP 1 uses AppService user from STEP 1 if possible
    const { isLoadingMsal, accessTokenMsal, logOut: logoutMsal } = useMsalAuth();

    // STEP 2: Auth with middleware using user's AD access token
    const {
        callingFetchMiddleware, accessTokenMiddleware, userMiddlewareError,
        refetchUserToken,
    } = useMiddlewareAuth(isImpersonated ? undefined : accessTokenMsal);

    const apiAccessToken = useMemo(() => tokenImpersonate || accessTokenMiddleware || null, [tokenImpersonate, accessTokenMiddleware]);
    const apiUser = useMemo(() => {
        try {
            return apiAccessToken ? jwtDecode(apiAccessToken) : null;
        } catch {
            return null;
        }
    }, [apiAccessToken]);

    const isAuthenticated = !!apiUser?.PG && isTokenSet;
    const isAuthenticating = !isTokenSet || isLoadingMsal || callingFetchMiddleware || (!isImpersonated && !accessTokenMiddleware && !userMiddlewareError);
    const showErrorPage = !isAuthenticating && !isAuthenticated;

    useEffect(() => {
        if (apiAccessToken) {
            axiosManager.setAuthToken(`Bearer ${apiAccessToken}`);
            setIsTokenSet(true);
        }
    }, [apiAccessToken]);
    useEffect(() => {
        // setTokenExpirationCheck
        if (apiUser?.iat) {
            sessionStorage.setItem("iat", apiUser.iat);
        }
    }, [apiUser?.iat]);

    const logOut = () => {
        logoutMsal?.();
        clearImpersonation?.();
        axiosManager.removeAuthToken();
        sessionStorage.removeItem("iat");
        const keys = Object.keys(sessionStorage);
        keys.forEach((key) => {
            if (key.startsWith("contractModal__")) {
                sessionStorage.removeItem(key);
            }
        });
    };

    return {
        isAuthenticated,
        isAuthenticating,
        showErrorPage,
        azureAccessToken: accessTokenMsal,
        apiUser,
        apiAccessToken,
        logOut,
        refetchUserToken,
    };
}
